module.exports={"(optional)":"(選填)","(required)":"(必填)"};